module.exports = __webpack_public_path__ + "img/ltkwedding-3x.748266d.jpg";